module.exports = __webpack_public_path__ + "img/ticket1.56a44227.png";